<header
  *ngIf="version !== 3"
  class="cmx-main-nav"
  [ngClass]="{ 'cmx-main-nav--mobile': isMobile, 'cmx-main-nav--green': isGreen }"
>
  <div
    *ngIf="isMobile && !((layout.isMobileEntitySelectorOpen | async) || (layout.isMobileLangSelectorOpen | async))"
    class="cmx-main-nav__trigger"
    [ngClass]="{ 'cmx-main-nav__trigger--rtl': direction === 'rtl' }"
  >
    <span (click)="openMobileMenu()" class="cmx-icon-menu"></span>
  </div>
  <div class="cmx-logo" (click)="buttons.logo.emit()">
    <ng-content></ng-content>
  </div>
  <div *ngIf="!isMobile" class="cmx-main-nav__items">
    <!-- Employee Menu Block-->
    <div
      *ngIf="layout.consolesMenu | async"
      class="cmx-main-nav__item cmx-consoles"
      [ngClass]="{ 'cmx-main-nav__item--rtl': direction === 'rtl' }"
    >
      <cmx-header-employee-menu
        *ngFor="let console of layout.consolesMenuItems | async"
        [console]="console"
      ></cmx-header-employee-menu>
    </div>
    <!-- Feedback Block -->
    <div
      id="cmx-header-feedback"
      *ngIf="layout.feedback | async"
      (click)="layout.feedbackClick.emit()"
      class="cmx-feedback cmx-main-nav__item"
      [ngClass]="{ 'cmx-main-nav__item--rtl': direction === 'rtl' }"
    >
      {{ layout.feedbackLabel | async }}
    </div>
    <!-- Notification Block -->
    <div
      *ngIf="notificationsService.notificationsEnabled | async"
      class="cmx-main-nav__item"
      [ngClass]="{ 'cmx-main-nav__item--rtl': direction === 'rtl' }"
    >
      <cmx-notifications></cmx-notifications>
    </div>
    <!-- Apps Menu Block -->
    <div #appMenuRef *ngIf="layout.appMenu | async" class="cmx-main-nav__item cmx-app-menu" (click)="toggleAppMenu()">
      <div
        class="cmx-icon-modules-internal-consoles cmx-icon--hover cmx-app-menu__icon"
        [ngClass]="{ 'cmx-icon--selected': isAppMenuOpen }"
      ></div>
      <div
        class="popout popout--with-border cmx-app-menu__container"
        [ngClass]="{
          'cmx-app-menu__container--closed': !isAppMenuOpen,
          'cmx-app-menu__container--rtl': direction === 'rtl',
          'popout--bottom-left': direction === 'ltr',
          'popout--bottom-right': direction === 'rtl'
        }"
      >
        <div class="cmx-app-menu__label">
          {{ layout.appMenuLabel | async }}
        </div>
        <div class="cmx-app-menu__items">
          <div
            *ngFor="let item of layout.appMenuItems | async; index as i"
            class="cmx-app-menu__item"
            (mouseenter)="appItemHovered = i"
            (mouseleave)="appItemHovered = -1"
            (click)="appMenuClick(item.id)"
          >
            <div class="cmx-icon cmx-app-menu__item-icon-container">
              <span class="cmx-app-menu__item-icon" [ngClass]="item.icon"></span>
            </div>
            <div
              class="cmx-app-menu__item-label"
              [ngClass]="{ 'cmx-app-menu__item-label--hovered': appItemHovered === i }"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Avatar Block -->
    <div
      #navMenuRef
      class="cmx-main-nav__item cmx-user-menu"
      [ngClass]="{ 'cmx-main-nav__item--rtl': direction === 'rtl' }"
    >
      <div
        (click)="toggleNavMenu()"
        class="cmx-icon cmx-icon--inverted cmx-icon--hover"
        [ngClass]="{ 'cmx-icon--selected': isNavMenuOpen }"
      >
        {{ layout.userInitials | async }}
      </div>
      <div
        class="popout popout--with-border cmx-user-menu__container"
        [ngClass]="{
          'cmx-user-menu__container--closed': !isNavMenuOpen,
          'cmx-user-menu__container--rtl': direction === 'rtl',
          'popout--bottom-left': direction === 'ltr',
          'popout--bottom-right': direction === 'rtl'
        }"
      >
        <div
          (click)="!showMyProfile ? userClick() : null"
          [ngClass]="showMyProfile ? 'cursor-auto' : ''"
          class="cmx-user-menu__user"
          data-tid="cmx-nav-header-btn-myprofile"
          id="cmx-nav-header-btn-myprofile"
        >
          <div class="cmx-icon">{{ layout.userInitials | async }}</div>
          <div
            class="cmx-user-menu__user-details"
            [ngClass]="{ 'cmx-user-menu__user-details--rtl': direction === 'rtl' }"
          >
            <div class="cmx-user-menu__user-name">{{ fullName }}</div>
            <div class="cmx-user-menu__user-email">{{ layout.userEmail | async }}</div>
          </div>
        </div>
        <div
          (click)="userClick()"
          class="cmx-user-menu__heading"
          *ngIf="showMyProfile"
          id="cmx-nav-header-btn-myprofile"
          data-tid="cmx-nav-header-btn-myprofile"
        >
          {{ buttons.myProfileLabel | async }}
        </div>
        <ng-container *ngFor="let item of layout.headerMenuItems | async">
          <div
            (click)="toggleSubmenu(item)"
            class="cmx-user-menu__heading"
            [ngClass]="{
              'cmx-user-menu__heading--open': item.id === openedSubmenu,
              'cmx-user-menu__heading--closed': item.subMenu && item.subMenu.length > 0
            }"
          >
            {{ item.label }}
          </div>
          <ul
            *ngIf="item.subMenu && item.subMenu.length > 0"
            class="cmx-user-menu__options-list scrollbar"
            [ngClass]="{ 'cmx-user-menu__options-list--open': item.id === openedSubmenu }"
          >
            <li
              class="cmx-user-menu__options-item"
              *ngFor="let subItem of item.subMenu"
              [ngClass]="{ 'cmx-user-menu__options-item--active': subItem.active }"
              (click)="headerMenuClick(subItem.id)"
            >
              <span></span>
              {{ subItem.label }}
            </li>
          </ul>
        </ng-container>
        <ng-container *ngIf="layout.language | async">
          <div
            (click)="toggleLanguageMenu()"
            class="cmx-user-menu__heading cmx-user-menu__heading--closed"
            [ngClass]="{ 'cmx-user-menu__heading--open': isLanguageMenuOpen }"
          >
            {{ layout.languageLabel | async }}
          </div>
          <ul
            class="cmx-user-menu__options-list scrollbar"
            [ngClass]="{ 'cmx-user-menu__options-list--open': isLanguageMenuOpen }"
          >
            <li
              class="cmx-user-menu__options-item"
              *ngFor="let language of layout.languages | async"
              [ngClass]="{ 'cmx-user-menu__options-item--active': language.languageId === activeLanguageId }"
              (click)="changeLanguage(language)"
            >
              <span></span>
              {{ language.languageName }}
            </li>
          </ul>
        </ng-container>
        <div (click)="logout()" class="cmx-user-menu__heading">
          {{ buttons.logoutLabel | async }}
        </div>
      </div>
    </div>
  </div>
</header>
<cwc-header
  id="navHeader"
  *ngIf="version === 3"
  [showMenuButton]="true"
  [menuButtonLabel]="menuButtonLabel"
  [variant]="variant"
  [dir]="direction"
  (cwcLogoClick)="gotoHome()"
  class="cmx-nav-header__component {{ variant }}"
  [brandLogo]="layout.brandLogo | async"
  (cwcSidenavToggle)="toggleCollapse()"
  (cwcRendered)="headerRendered($event)"
>
  <div
    class="cmx-nav-header__section cmx-nav-header__section--{{
      (layout.userCountry | async) == 'IL' ? 'il-' : ''
    }}separated cmx-nav-header__section__inline"
  >
    <cwc-popover #helpPopover>
      <cwc-button (click)="renderContent('help')" slot="target" variant="link" white id="headerHelpButton">
        <span
          class="cmx-nav-header__help-button cmx-nav-header{{
            (layout.userCountry | async) == 'IL' ? '-il' : ''
          }}__label-help"
        >
          {{ needHelpLabel }}
          <cwc-icon
            name="arrow-down-single"
            size="12px"
            [color]="(layout.userCountry | async) == 'IL' ? 'true-white' : 'bright-blue-dark'"
          ></cwc-icon>
        </span>
        <span class="cmx-nav-header__icon cmx-nav-header__icon--help">
          <cwc-icon
            name="module-help-support"
            [color]="variant === 'negative' ? 'true-blue' : 'true-white'"
            size="1.5rem"
          ></cwc-icon>
        </span>
      </cwc-button>
      <div slot="content" class="cmx-nav-header__help-popover" id="headerHelpPopout">
        <div class="cmx-nav-header__help-sc" *ngIf="_showServiceCenter" (click)="goToSupportCenter()">
          <div class="cmx-nav-header__help-sc-icon">
            <cwc-icon
              name="support-center"
              [color]="variant === 'negative' ? 'true-blue' : 'true-white'"
              size="1.5rem"
            ></cwc-icon>
          </div>
          <div class="cmx-nav-header__help-sc-text">
            <h4>{{ ServiceCenterApp }}</h4>
          </div>
        </div>
        <ul class="cmx-nav-header__help-menu" role="navigation">
          <li class="cmx-nav-header__help-menu-item cmx-nav-header__chatbot" *ngIf="showChatbot && chatbotRealocated">
            <cwc-button variant="link" (cwcClick)="openAivoChat()">
              <cmx-chatbot
                [relativeSettings]="{ enabled: true, popupPosition: 'bottom' }"
                [languageISO]="activeLanguage$ | async"
              ></cmx-chatbot>
              {{ chatbotLabel }}
            </cwc-button>
          </li>
          <li
            class="cmx-nav-header__help-menu-item"
            *ngIf="layout.feedback | async"
            (click)="layout.feedbackClick.emit()"
          >
            <cwc-button variant="link"> {{ layout.feedbackLabel | async }} </cwc-button>
          </li>
          <!-- end .user-menu__settings -->
          <li class="cmx-nav-header__help-menu-item" *ngIf="layout.supportContact | async as contact">
            <cwc-button variant="link" id="cmx-header-country-support-button" (cwcClick)="headerMenuClick(contact.id)">
              {{ contact.label }}
            </cwc-button>
          </li>
          <li class="cmx-nav-header__help-menu-item" id="cmx-header-walkme-button">
            <!-- we leave this li to accept the walkme button -->
            <div id="cmx-header-feedback" class="btn-walkme">&nbsp;</div>
          </li>
        </ul>
      </div>
    </cwc-popover>
    <cmx-chatbot
      *ngIf="showChatbot && chatbotRealocated"
      [relativeSettings]="{ enabled: true, popupPosition: 'left' }"
      [languageISO]="activeLanguage$ | async">
    </cmx-chatbot>
  </div>
  <div class="cmx-item-v3">
    <div *ngIf="notificationsService.notificationsEnabled | async" class="notifications">
      <cmx-notifications></cmx-notifications>
    </div>
    <div class="consoles">
      <!--consoles navigation-->
      <cwc-popover #consolesPopover>
        <cwc-button (click)="renderContent('consoles')" slot="target" variant="link" white id="consolesPopoutButton">
          <span class="cmx-nav-header__icon cmx-nav-header__icon--consoles">
            <cwc-icon
              name="modules-internal-consoles"
              [color]="variant === 'negative' ? 'true-blue' : 'true-white'"
              size="1.25rem"
            ></cwc-icon>
          </span>
        </cwc-button>
        <div slot="content" class="cmx-nav-header__apps-popover" id="consolesPopout">
          <h3 class="cmx-nav-header__apps-heading">CEMEX Apps</h3>
          <ul class="cmx-nav-header__apps-list">
            <li
              class="cmx-nav-header__apps-item"
              role="button"
              *ngFor="let item of layout.appMenuItems | async; index as i"
            >
              <cwc-button variant="link" (cwcClick)="appMenuClick(item.id)">
                <div class="cmx-nav-header__apps-link">
                  <div class="cmx-nav-header__apps-icon-wrapper">
                    <cwc-icon
                      *ngIf="item.icon"
                      [name]="item.icon.replace('cmx-icon-', '')"
                      color="true-white"
                      aria-hidden="true"
                    ></cwc-icon>
                  </div>
                  <span class="cmx-nav-header__apps-label"> {{ item.name }} </span>
                </div>
              </cwc-button>
            </li>
          </ul>
        </div>
      </cwc-popover>
    </div>
    <div class="avatar">
      <!-- user menu -->
      <cwc-popover #profilePopover>
        <cwc-avatar
          id="cmx-header-profile-menu"
          class="cmx-nav-header__user-avatar"
          slot="target"
          size="small"
          [name]="fullName"
          [variant]="'positive'"
          (click)="renderContent('profile')"
        >
        </cwc-avatar>
        <div slot="content" class="cmx-nav-header__user-popover {{ layout.userCountry | async }}" id="userMenuPopout">
          <div
            class="cmx-nav-header__user-profile cmx-nav-header__user-item"
            id="cmx-header-profile-link"
            [ngClass]="showMyProfile ? 'cursor-auto' : ''"
            (click)="!showMyProfile ? userClick() : null"
            role="button"
          >
            <div class="cmx-nav-header__user-profile-avatar">
              <cwc-avatar size="small" [name]="fullName" [variant]="'negative'"></cwc-avatar>
            </div>
            <div class="cmx-nav-header__user-profile-details">
              <h4 class="cmx-nav-header__user-name">{{ fullName }}</h4>
              <span class="cmx-nav-header__user-email">{{ layout.userEmail | async }}</span>
            </div>
          </div>
          <div (click)="userClick()" class="cmx-user-menu__heading" *ngIf="showMyProfile" id="cmx-header-profile-link">
            {{ buttons.myProfileLabel | async }}
          </div>
          <ng-container *ngFor="let item of layout.headerMenuItems | async">
            <div
              (click)="toggleSubmenu(item)"
              class="cmx-user-menu__heading"
              [ngClass]="{
                'cmx-user-menu__heading--open': item.id === openedSubmenu,
                'cmx-user-menu__heading--closed': item.subMenu && item.subMenu.length > 0
              }"
            >
              {{ item.label }}
            </div>
            <ul
              *ngIf="item.subMenu && item.subMenu.length > 0"
              class="cmx-user-menu__options-list scrollbar"
              [ngClass]="{ 'cmx-user-menu__options-list--open': item.id === openedSubmenu }"
            >
              <li
                class="cmx-user-menu__options-item"
                *ngFor="let subItem of item.subMenu"
                [ngClass]="{ 'cmx-user-menu__options-item--active': subItem.active }"
                (click)="headerMenuClick(subItem.id)"
              >
                <span></span> {{ subItem.label }}
              </li>
            </ul>
          </ng-container>
          <ng-container *ngIf="layout.language | async">
            <div
              (click)="toggleLanguageMenu()"
              class="cmx-user-menu__heading cmx-user-menu__heading--closed"
              [ngClass]="{ 'cmx-user-menu__heading--open': isLanguageMenuOpen }"
            >
              {{ layout.languageLabel | async }}
            </div>
            <ul
              class="cmx-user-menu__options-list scrollbar"
              [ngClass]="{ 'cmx-user-menu__options-list--open': isLanguageMenuOpen }"
            >
              <li
                class="cmx-user-menu__options-item"
                *ngFor="let language of layout.languages | async"
                [ngClass]="{ 'cmx-user-menu__options-item--active': language.languageId === activeLanguageId }"
                (click)="changeLanguage(language)"
              >
                <span></span> {{ language.languageName }}
              </li>
            </ul>
          </ng-container>
          <div (click)="logout()" class="cmx-user-menu__heading">{{ buttons.logoutLabel | async }}</div>
        </div>
      </cwc-popover>
    </div>
  </div>
</cwc-header>
